var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('page-header',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',[_vm._v(" Minha conta 💻 ")])]},proxy:true}])}),_c('user-data')],1)}
var staticRenderFns = []

export { render, staticRenderFns }